import { useState } from 'react';
import { useAsyncEffect } from 'ahooks';
import { fetchUserSearchTrendingStatus } from '@home/services/search';

export default function useYearlyPosterNew(showYearlyPoster: boolean) {
  const [visible, setVisible] = useState(false);

  const handleClose = async () => {
    if (!showYearlyPoster) {
      return;
    }

    setVisible(false);
    await fetchUserSearchTrendingStatus({
      action: 'set',
      key: 'home_yearly_poster_read',
      value: '1',
    });
  };

  useAsyncEffect(async () => {
    if (!showYearlyPoster) {
      return;
    }

    try {
      const res = await fetchUserSearchTrendingStatus({
        action: 'get',
        keys: ['home_yearly_poster_read'],
      });
      setVisible(res?.home_yearly_poster_read !== '1');
    } catch (error) {
      console.error(error);
    }
  }, [showYearlyPoster]);

  return { visible, onClose: handleClose };
}
